// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__102KM","cell":"ColumnAccessor_cell__3YcvD","firstCellAccent":"ColumnAccessor_firstCellAccent__2ber8"};